<template>
	<div class="mainWrapper direct-purchase">
		<h1>Direct Purchase</h1>

		<div class="links">
			<!-- <b-button type="is-info"
				><router-link to="/export/direct-purchase">
					Export Direct Purchase
				</router-link></b-button
			> -->

			<button @click="newDP()" class="big-button">
				+ Add New
			</button>

			<button @click="importDP()" class="big-button">
				+ Import
			</button>

			<button @click="exportDP()" class="big-button">
				+ Export
			</button>
		</div>

		<div class="list" v-if="list">
			<div class="dpList header">
				<div>DP CODE</div>
				<div>CREATED BY</div>
				<div>CREATED DATE</div>
				<div></div>
			</div>

			<div v-for="(item, index) of list" v-bind:key="index" class="dpList">
				<div>{{ item.code }}</div>
				<div>{{ item.author.name }}</div>
				<div>{{ convertTime(item.createdAt) }}</div>
				<div @click="viewDP(item._id)" class="hyperlink">
					<ios-arrow-forward-icon w="32px" h="32px" />
				</div>
			</div>

			<paginate
				v-model="page"
				:page-count="pageCount"
				:click-handler="pagerClick"
				:prev-text="'prev'"
				:next-text="'next'"
				:container-class="'pagination'"
			>
			</paginate>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DirectPurchase',
	data: function() {
		return {
			limit: this.$config.pageItemsLimit, // For pager
			list: null, // Will contain all the list
			pageCount: 1, // For pager
			page: 1 // For pager
		}
	},
	mounted: async function() {
		// Get all the PO
		var data = {
			limit: this.limit,
			populate: ['author']
		}

		const apiGetDP = await this.$api.getDP({ data })

		this.pageCount = Math.ceil(apiGetDP.data.total / this.limit)

		this.list = apiGetDP.data.list
	},

	methods: {
		importDP: function() {
			this.$router.push('/direct-purchase/import')
		},

		newDP: function() {
			this.$router.push('/add-direct-purchase')
		},

		exportDP: function() {
			this.$router.push('/direct-purchase/export')
		},

		viewDP: function(id) {
			this.$router.push('/direct-purchase/' + id)
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		},

		pagerClick: async function(pageNumber) {
			// Calculate how many items to skip
			var skip

			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = {
				limit: this.limit,
				skip,
				populate: ['author']
			}

			const apiGetPI = await this.$api.getDP({ data })

			this.pageCount = Math.ceil(apiGetPI.data.total / this.limit)

			this.list = apiGetPI.data.list
		}
	}
}
</script>

<style scoped>
.add-new-button {
	margin: 20px 0;
}

.dp-search {
	margin: auto;
	width: 500px;
	display: grid;
	grid-template-columns: 1fr 1fr 100px;
	grid-gap: 10px;
}

.list {
	margin-top: 20px;
}

.dpList {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 50px;
	grid-gap: 10px;
	padding: 16px 5px 5px;
	font-weight: bold;
	font-size: 14px;
	color: #000;
	border-bottom: 1px solid #eee;
}

.header {
	color: #aaa;
	font-weight: bold;
	font-size: 14px;
	margin-bottom: 10px;
}

.detail-buttons-wrapper {
	display: grid;
	grid-template-columns: 1fr 1fr;
	margin: auto;
}

.links {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 10px;
	width: 600px;
}
</style>
